import React, { useRef, useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { mdiChevronDown } from "@mdi/js";
import { Button } from "./Button";
import { UserContext } from "../contexts/UserContext";

const DropdownStyle = styled.div`
    display: flex;
    position: relative;
    >button:nth-child(1) {
        z-index: 1;
        border-radius: 2px 0 0 2px;
    }
    >div:nth-child(2) {
        width: 1px;
        background-color: ${props => props.theme.greyLight};
    }
    >button:nth-child(3) {
        padding: 0 6px;
        border-radius: 0 2px 2px 0;
    }
`;

const OptionsStyle = styled.div`
    top: 100%;
    z-index: 999;
    position: absolute;
    box-shadow: 0 4px 5px 3px rgba(0, 0, 0, 0.2);
    background-color: ${props => props.theme.white};
    border: 1px solid ${props => props.theme.greyLight};
`;

const OptionStyle = styled.div`
    gap: 6px;
    display: flex;
    font-size: 14px;
    cursor: pointer;
    align-items: center;
    margin: 8px 5px;
    white-space: nowrap;
    padding: 8px 14px 8px 10px;
    color: ${props => props.theme.black};
    &:hover {
        border-radius: 2px;
        color: ${props => props.theme.white};
        background-color: ${props => props.theme.primaryLight};
    }
`;

export const Option = props => <>{props.children}</>;

export const Dropdown = React.memo(props => {

    const { disabled, children, svgIcon, value, simulateLoading } = props;

    const userContext = useContext(UserContext);
    const node = useRef(null);

    const [showOptions, setShowOptions] = useState(false);
    const [availableOptions, setAvailableOptions] = useState([]);

    //prevents the select from losing focus when option is clicked
    const onMouseDown = event => event.preventDefault();

    const onBlur = () => setShowOptions(false);

    useEffect(() => {
        if (children === undefined) {
            return;
        }
        const entries = [children]
            .flatMap(child => (Array.isArray(child) ? child : [child]))
            .filter(child => child !== undefined)
            .filter(child => child.type === Option)
            .filter(child => userContext.checkFeature(child.props.featureFor))
            .map(child => child.props);
        setAvailableOptions(entries);
    }, [children]);

    const onClickOption = (event, option) => {
        option.onClick(event);
        setShowOptions(!showOptions);
    };

    return (
        <>
            <DropdownStyle ref={node} onBlur={onBlur}>
                <Button
                    svgIcon={svgIcon}
                    value={value}
                    disabled={disabled}
                    onClick={props.onButtonClick}
                    simulateLoading={simulateLoading} />
                <div />
                <Button
                    onClick={() => setShowOptions(!showOptions)}
                    svgIcon={mdiChevronDown} disabled={disabled} />
                {showOptions &&
                    <OptionsStyle
                        onMouseDown={onMouseDown}>
                        {availableOptions.map((option, index) =>
                            option.disabled !== true &&
                            <OptionStyle key={index}
                                onClick={event => onClickOption(event, option)}>
                                <div>{option.children}</div>
                            </OptionStyle>
                        )}
                    </OptionsStyle>
                }
            </DropdownStyle>
        </>
    );
});